<template>
    <rkm-form
        v-if="loaded"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.grupos"
                    :validations="validations.grupoExameId"
                    label="Grupo"
                    show-default-option
                    text-field="nome"
                    v-model="model.grupoExameId"
                    value-field="id"
                    @change="handleGrupoChange"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.procedimento"
                    :requestQueryStringParams="autocompletesResquestParams.queryString"
                    :searchFields="fields.autocompletes.procedimento"
                    :text-field="e => `${e.codigo} - ${e.nome}`"
                    label="Procedimento"
                    v-model="model.procedimento"
                 >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-radio-group v-model="model.searchByApelido">
                                <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input-autocomplete>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :disabled="!model.isRegulado"
                    :label="false"
                    :options="form.regulacaoTipo"
                    name="Tipo de regulação"
                    show-default-option
                    text-field="nome"
                    v-model="model.regulacaoTipoId"
                    value-field="id"
                    :validations="validations.regulacaoTipoId"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                @change="handleReguladoChange"
                                v-model="model.isRegulado"
                            >
                                Regulado
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>

                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                :disabled="!model.isRegulado"
                                @change="handlePpiChange"
                                v-model="model.isPpi"
                            >
                                PPI
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-select>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :disabled="!model.isPpi"
                    :validations="validations.valorPpi"
                    key="valorPpi"
                    label="Valor PPI"
                    prepend="R$"
                    ref="valorPpi"
                    v-model="model.valorPpi"
                    v-money="money"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacao"
                    label="Observação"
                    v-model="model.observacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-checkbox
                    v-model="model.status"
                    inline
                >
                    Ativo
                </rkm-form-checkbox>
            </rkm-col>
            <rkm-col cols="10">
                <rkm-form-checkbox
                    v-model="model.exigirPesoAlturaCircunferencia"
                    inline
                >
                    Exigir peso, altura e circunferência abdominal
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>
<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error, formats } from '@/mixins'

// Directives.
import { VMoney } from 'v-money'

export default {
    computed: {
        autocompletesResquestParams() {

            return {
                queryString: {
                    procedimento: true,
                    search_by_apelido: this.model.searchByApelido,
                },
            }
        },
        fields() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            const regulacaoTipoId = this.model.isRegulado ? { required: true } : {}

            return {
                procedimento: { required: true },
                nome: { required: true, max: 100 },
                grupoExameId: { required: true },
                regulacaoTipoId: regulacaoTipoId,
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacaoProcedimentoCirurgico: this.getConectaSusRepository('parametrizacao.procedimentoCirurgico'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

        this.load()
    },
    data: () => ({
        model: {},
        form: {},
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 2,
            masked: false
        },
        loaded: false,
    }),
    directives: { money: VMoney },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.parametrizacaoProcedimentoCirurgico.edit(this.id)
                : this.repositories.parametrizacaoProcedimentoCirurgico.create()

            request
                .then(({ data }) => {
                    this.model = data.model;
                    this.form = data.form;

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleGrupoChange(selectedId) {
            this.handleReguladoChange()

            const selectedGrupo = this.form.grupos.find(grupo => grupo.id === selectedId)

            if (selectedGrupo && selectedGrupo.regulacaoTipoId) {

                this.model.isRegulado = true
                this.model.regulacaoTipoId = selectedGrupo.regulacaoTipoId
            } else {

                this.model.isRegulado = false
                this.model.regulacaoTipoId = null
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.parametrizacaoProcedimentoCirurgico.update(this.id, this.prepareData())
                        : this.repositories.parametrizacaoProcedimentoCirurgico.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            if (data.procedimento) {

                data.procedimentoCodigo = data.procedimento.codigo
            }

            delete data.procedimento

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        handleReguladoChange() {

            this.model.regulacaoTipoId = null
            this.model.isPpi = false

            this.handlePpiChange()
        },
        handlePpiChange() {

            this.model.valorPpi = '0,00'
            this.$refs.valorPpi.$el.getElementsByTagName('input')[0].value = '0,00'
        }
    },
    mixins: [repository, stringCase, object, error, formats],
    props: {
        id: { type: Number },
    },
}
</script>